module.exports = __webpack_public_path__ + "img/s5.31391ccc.jpg";